import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import type { InputProps, TemporaryPassword } from '../../../../../types/Form';
import Input from '../../../Form/Input';
import type { HookInputBaseProps } from '../../types';

export interface HookInputProps<T extends FieldValues = FieldValues> extends InputProps, HookInputBaseProps<T>, TemporaryPassword {
  name: FieldPath<T>;
}

export const HookInput = <T extends FieldValues>(props: HookInputProps<T>) => {
  const { name, required, validate, id, formMethods, ...rest } = props;
  const { control, setError } = useFormContext<T>();
  const idOrName = id || name;

  if (props.error) {
    setError(name, { type: 'manual', message: props.error.toString() });
  }

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control || control}
      render={({ field, fieldState: { error, isTouched } }) => (
        <>
          <Input {...rest} {...field} id={idOrName} error={error?.message} />
        </>
      )}
    />
  );
};
